import CryptoJS from 'crypto-js';
import moment from 'moment';

const HTTP="//";

//digital.mv1.in for dev //10.98.1.87:2222 //http://fundooozone.com/
const CONTENT_IP_ADRESS="mv1.in";
const CONTEST_IP_ADRESS = "mv1.in";
const SPSBILLING_IP_ADRESS = "mv1.in";
const PROFILER_IP_ADDRESS ="mv1.in";

const SPS_PROJECT_NAME="SPSBilling"


const CONTEST_PROJECT_NAME="ContestLeague";
const CONTENT_MANAGER_PROJECT_NAME="ContentManager2";

//APP CONFIGURATION
export const APP_ID = 27;
export const CHANNEL = "WAP";
export const DEVICE_ID = 5;
export const OPERATOR = "mtnghana"; //vodafoneqatar for test
export const FRONT_END_NAME = "/healthportal";
export const APP_KEY = "GhanaHealthPortal";
export const CATEGORY = "";
export const COUNTRY_CODE="233";
export const PACK_NAME="mypackname";
export const APPLICATION_JSON="application/json";

export const SPL_CHAR_REGEX = /[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi;
export const ADDRESS_REGEX = /[`~!@#$%^&*()_|+\=?;:'"<>\{\}\[\]]/gi;
export const ONLY_NUM_REGEX = /[^0-9]/g;
export const ONLY_ALPHA_REGEX = /[^A-Za-z ]/g;
export const VALIDATE_MOBILE_NO_REGEX = /^[6-9]\d{9}$/;
export const VALIDATE_EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const OTP_LENGTH = 4;
// -------------------------------------------------------
export const SESSION_ID_TIMEOUT = "30";


export function copyObject (obj){
    return JSON.parse(JSON.stringify(obj));
}



const SECRET_KEY="MYSECRETKEY"

export function setObjectInSS(key,Object){
    sessionStorage[key] = Object;
}


export function getObjectFromSS(key){
    return JSON.parse(sessionStorage[key]);
}
export function convertObjectBeforeSaving(Object){
    var encData = CryptoJS.AES.encrypt(JSON.stringify(Object), SECRET_KEY).toString();
    return encData;
}
export function parseObjectBeforeGet(key){
  
    var bytes = CryptoJS.AES.decrypt(sessionStorage[key], SECRET_KEY);
    var decryptedData = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decryptedData);
}

export function isValidMsisdn (msisdn){
  var pattern = new RegExp(VALIDATE_MOBILE_NO_REGEX);
  return !(msisdn == null || msisdn == '' || !pattern.test(msisdn));
}
export function validateEmail(email) {
  const re = VALIDATE_EMAIL_REGEX;
  return re.test(String(email).toLowerCase());
}

export function convertToContestTimeFormat(date){
   //moment().format("DD MMM YYYY hh:mm a");
   return moment(date).format("dddd, DD MMM YYYY")
}

export function convertSecondsToMinute(data){
    if(data == undefined || data == null || data == ""){data="0"}
    console.log("data passed",data);
    return moment("2015-01-01").startOf('day')
    .seconds(data)
    .format('mm:ss');
}

export function getCommonHeaders (){
    var headers = {}; 
    
        headers = {
            'Content-Type': 'application/json',
            'access_token': 'usersession.access_token',
            'appid': APP_ID,
            
            
        };
    
    return headers;
}

export const Profiler_ENGINE_IP_ADDRESS=HTTP+PROFILER_IP_ADDRESS+"/"+"Profiler";
export const CONTEST_META_INFO=HTTP+CONTEST_IP_ADRESS+"/"+"ContestLeague/contestMetaInfo";
export const CONTEST_ADDRESS=HTTP+CONTEST_IP_ADRESS+"/"+"ContestLeague";
export const CHECK_GENERIC_SUBS_API_PARAM="/v1/checkSubscriptionGeneric?msisdn=<xxmsisdn>&appKey=<xxappKey>&operator=<xxoperator>"
export const SPS_COMBINED_IP=HTTP+SPSBILLING_IP_ADRESS+"/"+SPS_PROJECT_NAME; 
export const GET_CONTENT_BANNER=HTTP+CONTENT_IP_ADRESS+"/"+"ContentManager2/v1/fetchHomePage";
export const FAQ_API_PARM="/v1/fetchSettings?settingKey=faq";
export const HTP_API_PARM="/v1/fetchSettings?settingKey=htp";
export const LEADERBOARD_API_PARM="/getLeaderBoardDetailsOnlyTotalScore";

export const CONTENT_COMBINED_IP=HTTP+CONTENT_IP_ADRESS+"/"+CONTENT_MANAGER_PROJECT_NAME;
export const CONTEST_ENGINE_COMBINED_IP=HTTP+CONTEST_IP_ADRESS+"/"+CONTEST_PROJECT_NAME; 



export const SHARE_SCREEN_CONTENT = "Checkout this new game "

export const TOPUP_REQUIRED = "You have exceeded the daily limit, Keep on playing with the score booster pack #QAR# Questions.";
export const MAX_QUESTION_PLAYED = "Played maximum questions for the day, Please come back tommorow.";
export const INSUFFICIENT_BALANCE ="Insufficient balance, Kindly recharge."

